<template>
    <section class="l-section" data-jest="error-not-found">
        <heading-section title="ページが見つかりません" />
        <heading-plain text="考えられる理由" :isCenter="true" />
        <div class="l-element">
            <ul class="l-element m-list-text">
                <li class="m-list-text-item">すでに削除・変更されている</li>
                <li class="m-list-text-item">一時的に利用できなくなっている</li>
                <li class="m-list-text-item">ご入力いただいたURLが間違っている</li>
            </ul>
        </div>
        <div class="l-element">
            <p class="m-text-normal"> お手数ですが、以下のボタンから目的のページをお探しいただくか、URLを再度ご確認ください。</p>
        </div>
        <div class="l-element">
            <btn link="/" text="ピクトリンクTOPへ"/>
        </div>
    </section>
</template>

<script>
    import HeadingSection from '../atoms/HeadingSection.vue'
    import HeadingPlain from '../atoms/HeadingPlain.vue'
    import Btn from '../atoms/Btn.vue'
    export default {
        name: "ErrorNotFoundContent",
        components: {
            HeadingSection,
            HeadingPlain,
            Btn
        }
    }
</script>